module.exports = __webpack_public_path__ + "static/media/carrossel2.b9c98188.jpg";